// // ? executers interface
import { State as _DataCashlessOrders } from "./CashlessOrders/data/interface";
import { State as _DataCashlessOrdersGeneral } from "./CashlessOrdersGeneral/data/interface";
import { State as _DataCashlessOrdersPeriodReport } from "./CashlessOrdersPeriodReport/data/interface";
import { State as _DataCashlessAccountsSummaryReport } from "./CashlessAccountsSummaryReport/data/interface";
import { State as _DataAgentOrdersReport } from "./AgentOrdersReport/data/interface";
import { State as _DataAgentBillReport } from "./AgentBillReport/data/interface";
import { State as _DataSalaryReportsUsersActivity } from "./SalaryReportsUsersActivity/data/interface";
import { State as _DataExecutorOrdersReport } from "./ExecutorOrdersReport/data/interface";

export namespace Reports {
	export namespace CashlessOrders {
		export interface DataCashlessOrders extends _DataCashlessOrders {}
	}

	export namespace CashlessOrdersGeneral {
		export interface DataCashlessOrdersGeneral
			extends _DataCashlessOrdersGeneral {}
	}

	export namespace CashlessOrdersPeriodReport {
		export interface DataCashlessOrdersPeriodReport
			extends _DataCashlessOrdersPeriodReport {}
	}

	export namespace CashlessAccountsSummaryReport {
		export interface DataCashlessAccountsSummaryReport
			extends _DataCashlessAccountsSummaryReport {}
	}

	export namespace AgentOrdersReport {
		export interface DataAgentOrdersReport extends _DataAgentOrdersReport {}
	}

	export namespace AgentBillReport {
		export interface DataAgentBillReport extends _DataAgentBillReport {}
	}

	export namespace SalaryReportsUsersActivity {
		export interface DataSalaryReportsUsersActivity
			extends _DataSalaryReportsUsersActivity {}
	}

	export namespace ExecutorOrdersReport {
		export interface DataExecutorOrdersReport
			extends _DataExecutorOrdersReport {}
	}

	export const ConstantReportSlice = {
		CASHLESS_ORDERS: "reports/cashlessOrders/data",
		CASHLESS_ORDERS_GENERAL: "reports/cashlessOrdersGeneral/data",
		CASHLESS_ORDERS_PERIOD_REPORT:
			"reports/cashlessOrdersPeriodReport/data",
		CASHLESS_ACCOUNTS_SUMMARY_REPORT:
			"reports/cashlessAccountsSummaryReport/data",
		AGENT_ORDERS_REPORT: "reports/agentOrdersReport/data",
		AGENT_BILL_REPORT: "reports/agentBillReport/data",
		SALARY_REPORTS_USERS_ACTIVITY:
			"reports/salaryReportsUsersActivity/data",
		EXECUTOR_ORDERS_REPORT: "reports/executorOrdersReport/data",
	};
}
